import type { CSSProperties, ReactNode } from "react";

interface SectionProps {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  tight?: boolean;
  id?: string;
}

export function Section({ children, className, style, tight, id }: SectionProps) {
  const cls = ["vb-section", tight ? "vb-section-tight" : "", className].filter(Boolean).join(" ");
  return (
    <section id={id} className={cls} style={style}>
      {children}
    </section>
  );
}

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  lead?: string;
}

export function SectionHeading({ eyebrow, title, lead }: SectionHeadingProps) {
  return (
    <div style={{ marginBottom: 32, maxWidth: 720 }}>
      {eyebrow ? <span className="label" style={{ display: "block", marginBottom: 10 }}>{eyebrow}</span> : null}
      <h2
        style={{
          fontFamily: "var(--font-display)",
          fontSize: 44,
          lineHeight: 1.05,
          letterSpacing: "0.01em",
          margin: 0,
          color: "var(--fg-1)",
          textTransform: "uppercase",
        }}
      >
        {title}
      </h2>
      {lead ? (
        <p style={{ fontSize: 16, color: "var(--fg-2)", marginTop: 12, lineHeight: 1.55 }}>
          {lead}
        </p>
      ) : null}
    </div>
  );
}
